import InputBox from '@/components/dialog/InputBox.vue'
let ConfirmConstructor, instance

const showInputBox = {
  install(Vue) {
    ConfirmConstructor = Vue.extend(InputBox)
    instance = new ConfirmConstructor().$mount()
    document.body.appendChild(instance.$el)

    Vue.prototype.$showInputBox = options => {
      Object.assign(instance, options)
      instance.init()
    }

    Vue.prototype.$closeInputBox = options => {
      Object.assign(instance, options)
      instance.close()
    }


  }
}

export default showInputBox


// WEBPACK FOOTER //
// ./src/assets/js/inputBox.js